import type {PropsWithChildren} from "react";

export default function IsShowField({children, canShow}: PropsWithChildren<{canShow: boolean}>) {
  if (!canShow) return <></>;

  return <>{children}</>;
}
